import { createSlice } from '@reduxjs/toolkit';
import { WeekOffState } from './weekoff.Type';
import { createWeekoff , fetchAllWeekoff } from './weekoff.Action';

const initialState : WeekOffState ={
    weekoff : [],
    selectedweekoff : undefined,
    loadingStates : {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
}


const  weekoffSlice = createSlice ({
    name : 'weekoff' ,
    initialState,
    reducers:{},
    extraReducers : (builder) =>{
        builder
           .addCase(createWeekoff.pending, (state) => {
                                   state.loadingStates.create = true;
                                   state.errors.create = undefined;
                               })
                               .addCase(createWeekoff.fulfilled, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.weekoff.push(action.payload);
                               })
                               .addCase(createWeekoff.rejected, (state, action) => {
                                   state.loadingStates.create = false;
                                   state.errors.create = action.payload as string;
                               })
                   
                               // Update 
                            //    .addCase(Updatetermination.pending, (state) => {
                            //        state.loadingStates.update = true;
                            //        state.errors.update = undefined;
                            //    })
                            //    .addCase(Updatetermination.fulfilled, (state, action) => {
                            //        state.loadingStates.update = false;
                            //        const index = state.termination.findIndex((d : any) => d.Id === action.payload.Id);
                            //        if (index !== -1) {
                            //            state.termination[index] = action.payload;
                            //        }
                            //    })
                            //    .addCase(Updatetermination.rejected, (state, action) => {
                            //        state.loadingStates.update = false;
                            //        state.errors.update = action.payload as string;
                            //    })
                   
                               // Delete 
                            //    .addCase(deletetermination.pending, (state) => {
                            //        state.loadingStates.delete = true;
                            //        state.errors.delete = undefined;
                            //    })
                            //    .addCase(deletetermination.fulfilled, (state, action) => {
                            //        state.loadingStates.delete = false;
                            //        state.termination = state.termination.filter((d : any) => d.Id !== action.payload);
                            //    })
                            //    .addCase(deletetermination.rejected, (state, action) => {
                            //        state.loadingStates.delete = false;
                            //        state.errors.delete = action.payload as string;
                            //    })
                   
                               // Fetch  by ID
                            //    .addCase(fetchTerminationById.pending, (state) => {
                            //        state.loadingStates.fetchById = true;
                            //        state.errors.fetchById = undefined;
                            //    })
                            //    .addCase(fetchTerminationById.fulfilled, (state, action) => {
                            //        state.loadingStates.fetchById = false;
                            //        state.selectedResignation = action.payload;
                            //    })
                            //    .addCase(fetchTerminationById.rejected, (state, action) => {
                            //        state.loadingStates.fetchById = false;
                            //        state.errors.fetchById = action.payload as string;
                            //    })
                   
                               // Fetch All 
                               .addCase(fetchAllWeekoff.pending, (state) => {
                                   state.loadingStates.fetchAll = true;
                                   state.errors.fetchAll = undefined;
                               })
                               .addCase(fetchAllWeekoff.fulfilled, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.weekoff = action.payload.data;
                               })
                               .addCase(fetchAllWeekoff.rejected, (state, action) => {
                                   state.loadingStates.fetchAll = false;
                                   state.errors.fetchAll = action.payload as string;
                               }); 
    }
})

export default weekoffSlice.reducer;